import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Styled } from './styles';

type HrProps = ComponentPropsWithoutRef<'hr'>;

type Props = HrProps;

export const Divider = forwardRef<HTMLHRElement, Props>(({ ...props }, ref) => <Styled.Hr {...props} ref={ref} />);
Divider.displayName = 'Divider';
